import { useContext, useMemo } from 'react'
import { LabRemoteConfigKeys } from 'constants/lab'
import GeoContext from 'contexts/geoContext'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { resolveLoyaltyOffersHubRemoteConfig } from 'loyalty/lib/loyaltyOffersHub/resolveLoyaltyOffersHubRemoteConfig'

export function useLoyaltyOffersHubRemoteConfig() {
  const { currentRegionCode } = useContext(GeoContext)
  const payload = useLabRemoteConfig(LabRemoteConfigKeys.loyaltyOffersHubPage)

  return useMemo(
    () => resolveLoyaltyOffersHubRemoteConfig(payload, currentRegionCode),
    [payload, currentRegionCode],
  )
}
